import React from 'react';
import { Route, Routes } from 'react-router-dom';
import IdentificationCodeTypesOverview from '../components/IdentificationCodeTypesOverview';

const IdentificationCodeTypesScene = () => (
  <Routes>
    <Route
      path=":action?/:id?"
      element={<IdentificationCodeTypesOverview menuName="identificationcodetypes_plural" />}
    />
  </Routes>
);

export default IdentificationCodeTypesScene;
